import { Box, Typography } from "@mui/material";

const GitLabVariableDetailsView = ({ entityData }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {entityData?.gitlab_variable_data && (
        <>
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Variable Type</Typography>
            </Box>
            <Box ml={3} display="flex">
              <Typography variant="caption">
                {entityData.gitlab_variable_data.variable_type}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Description</Typography>
            </Box>
            <Box ml={3} display="flex">
              <Typography variant="caption">
                {entityData.gitlab_variable_data.description}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Protected</Typography>
            </Box>
            <Box ml={3} display="flex">
              <Typography variant="caption">
                {entityData.gitlab_variable_data.protected ? "Yes" : "No"}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Hidden</Typography>
            </Box>
            <Box ml={3} display="flex">
              <Typography variant="caption">
                {entityData.gitlab_variable_data.hidden ? "Yes" : "No"}
              </Typography>
            </Box>
          </Box>
          {entityData.gitlab_variable_data.group_name && (
            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle2">Group</Typography>
              </Box>
              <Box ml={3} display="flex">
                <Typography variant="caption">
                  {entityData.gitlab_variable_data.group_name}
                </Typography>
              </Box>
            </Box>
          )}
          {entityData.gitlab_variable_data.project_name && (
            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle2">Project</Typography>
              </Box>
              <Box ml={3} display="flex">
                <Typography variant="caption">
                  {entityData.gitlab_variable_data.project_name}
                </Typography>
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default GitLabVariableDetailsView;
